import { railHit, surfaceAt } from "../level";
import type { Skater } from "../skater";
import { dropToRamp } from "./lip";
import type { SkaterEvent } from "./state";
import { BAIL_TIME, STEP_UP } from "./tuning";

/** Bails; `wipeout` when it's into the sea (#82), which puts you back at the last safe spot afterwards. */
export function bail(sk: Skater, events: SkaterEvent[], wipeout = false): void {
  if (sk.mode === "ground") {
    const f = sk.forward;
    sk.vx = f.x * sk.speed;
    sk.vz = f.z * sk.speed;
  } else if (sk.mode === "grind" && sk.grind) {
    const g = sk.grind;
    const len = Math.hypot(g.rail.b.x - g.rail.a.x, g.rail.b.z - g.rail.a.z);
    sk.vx = ((g.rail.b.x - g.rail.a.x) / len) * g.dir * g.speed;
    sk.vz = ((g.rail.b.z - g.rail.a.z) / len) * g.dir * g.speed;
  } else if (sk.mode === "foot" && sk.foot) {
    const f = sk.forward;
    sk.vx = f.x * sk.foot.speed;
    sk.vz = f.z * sk.foot.speed;
  } else if (sk.mode === "lip") {
    // Fall back down the ramp side of the coping.
    dropToRamp(sk);
    sk.vx = sk.vz = 0;
  }
  sk.mode = "bail";
  sk.air = null;
  sk.lip = null;
  sk.bailT = 0;
  sk.revertWindow = 0;
  sk.linkWindow = 0;
  sk.nollie = false;
  sk.switchStance = false; // you get back up regular (#134)
  sk.resetBalance();
  sk.speed = 0;
  sk.grind = null;
  sk.manual = null;
  sk.manualBuffer = 0;
  sk.skitch = null;
  sk.foot = null;
  sk.combo.reset();
  sk.special.empty();
  events.push(wipeout ? { type: "bail", wipeout } : { type: "bail" });
}

export function stepBail(sk: Skater, dt: number): void {
  sk.bailT += dt;
  const damp = Math.max(0, 1 - 2.5 * dt);
  sk.vx *= damp;
  sk.vz *= damp;
  const nx = sk.x + sk.vx * dt;
  const nz = sk.z + sk.vz * dt;
  const s = surfaceAt(sk.level, nx, nz);
  if (!sk.outOfBounds(nx, nz) && s.h - sk.y < STEP_UP && !railHit(sk.level, sk.x, sk.z, nx, nz, sk.y)) {
    sk.x = nx;
    sk.z = nz;
  }
  const floor = surfaceAt(sk.level, sk.x, sk.z).h;
  sk.y = Math.max(floor, sk.y - 7 * dt);
  if (sk.bailT >= BAIL_TIME) {
    sk.mode = "ground";
    sk.speed = 0;
    sk.y = floor;
    sk.vx = sk.vy = sk.vz = 0;
    sk.crouch = 0;
  }
}
